<template>
  <div class="learingCourseTwo">
      <backHeader back-addr="/index"></backHeader>
    <div style="height:10px;"></div>
    <!-- <ul>
      <div @click="goIndexThird(item.id)" v-for="item in this.$route.query.items" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
        <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;color:#8F8F94;">{{ item.name }}</span></p>
        <img :src="item.imgurl" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
      </div>
    </ul> -->
    <ul>
      <!-- <li v-for="item in this.params.items"  @click="goNext(item)" style="text-align:left;color:gray;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:14px;">{{item.name}}</span><crossLine></crossLine></li> -->
      <div @click="goNext(item)" v-for="item in this.params.items" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
        <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;">{{ item.name }}</span></p>
        <img v-if="item.image" :src="item.image" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
      </div>
    </ul>
    <div style="height:50px;"></div>
  </div>
</template>
<script>

import Vue from "vue";
import openUrl from "./../utils/openUrl";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourse",
  data() {
    return {
      params:null,

      heightSize: 160,
      
      selected: this.$store.state.mineStore.tab,
      imgBaseUrl: cfg.imgBaseUrl,
 
    };
  },
  methods: {
  
    goNext(item) {
      if(item.leaf){
        if(item.directUrl){
          openUrl.open(item.directUrl);
        }
      }else{
        if(item.items){
          console.log("go next");
          console.log(item);
          this.params=item;
        }
      }
    },


  },
  created: function() {
    console.log("index two created");
    // console.log(this.$route.query.item.items);
    if(this.$route.params&&this.$route.params.id){
      console.log(this.$route.params);
      this.$store.commit("updateParams", JSON.stringify(this.$route.params));
      this.params=this.$route.params
    }else{
        console.log(JSON.parse(this.$store.state.mineStore.params));
        this.params=JSON.parse(this.$store.state.mineStore.params);
    }
    
  },
  mounted: function() {
   
  },
  components: {
    crossLine,
    commonHeader,
    backHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourseTwo {
  font-size:16px!important;
  font-weight:bold;
  color:rgb(68, 85, 102)!important;

  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-course/index-two.vue